import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, OnInit, inject } from "@angular/core";
import { AbstractControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { LgdFormControlFactory, LgdSelectComponent } from "@tylertech/lgd-reactive-forms";
import { Tuple } from "@tylertech/tyler-api-types";
import { BehaviorSubject, Observable } from "rxjs";

export interface DocTypeDialogData
{
    readonly docTypes: Tuple<string, string>[];
}

@Component({
    selector: "doc-type-dialog-component",
    templateUrl: "./docTypeDialog.tmpl.html",
    styleUrls: [
        "./docTypeDialog.component.scss"
    ],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        ReactiveFormsModule,
        LgdSelectComponent,
        MatDialogActions,
        MatButton
    ]
})
export class DocTypeDialogComponent implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<DocTypeDialogComponent, Tuple<string, string> | undefined>>(MatDialogRef);
    private readonly data = inject<DocTypeDialogData>(MAT_DIALOG_DATA);

    private readonly selectedTypesSubject = new BehaviorSubject<Array<Tuple<string, string>>>([]);
    readonly formGroup: FormGroup;

    constructor()
    {
        this.formGroup = new FormGroup({
            "selectedType": LgdFormControlFactory.select<Tuple<string, string>>(
                undefined,
                true,
                {
                    displayValueFn: x => x.Item1
                }),
        });
    }

    private get docTypes(): Tuple<string, string>[] { return this.data.docTypes; }
    protected get selectedTypeControl(): AbstractControl<Tuple<string, string>> { return this.formGroup.get("selectedType"); }

    get selectedTypesObservable(): Observable<Array<Tuple<string, string>>> { return this.selectedTypesSubject.asObservable(); }

    ngOnInit(): void
    {
        this.selectedTypeControl.setValue(this.docTypes[0]);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }

    confirm(): void
    {
        this.dialogRef.close(this.selectedTypeControl.value);
    }
}
